import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { map, find, without, indexOf, filter, uniq, size } from 'lodash';

import PixelSetBadge from './pixelSetBadge';
import PixelsIcons from './pixelsIcons';
import { removeLinkPixelSet } from '../../actions';

import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faPlus from '@fortawesome/fontawesome-pro-light/faPlus';
import faTimes from '@fortawesome/fontawesome-pro-light/faTimes';

import classNames from 'classnames';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import ModalLink from '../modals/ModalLink';

const mapStateToProps = state => ({ pixelSets: state.pixelSets, isLoading: state.loaders.pixelSets });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ removeLinkPixelSet }, dispatch)
};


class PixelSetsSelect extends Component {
  
  constructor (props) {
    super(props);
    this.onRemove = this.onRemove.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onCreateSuccess = this.onCreateSuccess.bind(this);
    
    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
    this.change = this.change.bind(this);
    
    this.toggle = this.toggle.bind(this);
    this.selectedOptions = this.selectedOptions.bind(this);
    
    this.state = {
      dropdownOpen: false,
      options: this.props.pixelSets,
      selectedIds: this.props.selectedIds || [],
      ignoreNewProps: false
    }
    
    setTimeout(this.selectedOptions)
  }
  
  componentWillReceiveProps(nextProps) {
    if (this.state.ignoreNewProps === false)
      this.setState({
        selectedIds: nextProps.selectedIds,
        ignoreNewProps: false
      })
    else
      this.setState({
        ignoreNewProps: false
      })
    setTimeout(this.selectedOptions)
  }
  
  selectedOptions() {
    const { pixelSets, selectedIds } = this.props;
    
    if (!pixelSets)
      return pixelSets
    
    const newOptions = filter(pixelSets, (pixelSet) => {
      return indexOf(selectedIds, pixelSet.id) < 0
    });
    
    this.setState({
      options: newOptions
    });
    
    return newOptions
  }
  
  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }
  
  
  change (newSelectedIds) {
    const { onChange } = this.props;
    
    this.setState({
      selectedIds: newSelectedIds,
      ignoreNewProps: true
    });
    return onChange instanceof Function && onChange( newSelectedIds )
  }
  
  add(id){
    return this.change( [...this.state.selectedIds, id] )
  }
  
  remove(id){
    return this.change( without(this.state.selectedIds, id) );
  }
  
  onAdd (id){
    return (e) => {
      if (e && e.preventDefault)
        e.preventDefault();
      this.add(id)
    }
  }
  
  onRemove (id) {
    return (e) => {
      if (e && e.preventDefault)
        e.preventDefault();
      return this.remove(id)
    }
  }
  
  onCreateSuccess (res){
    if (res && res.id )
      this.add(res.id)
  }
  
  render() {
    const { pixelSets, selectedIds, onChange, showEmptyMsg } = this.props;
    
    const selectedPixelSets = map(uniq([...selectedIds, ...this.state.selectedIds]), (id) => find(pixelSets, {id}));
    
    return (
      <span className="pixel-sets-select">
        { map(selectedPixelSets, (pixelSet, idx) => {
          if (!pixelSet)
            return
          const loading = indexOf(selectedIds, pixelSet.id) < 0 || indexOf(this.state.selectedIds, pixelSet.id) < 0
          return (<PixelSetBadge {...pixelSet} key={pixelSet.id} loading={loading} onRemove={onChange && this.onRemove(pixelSet.id)} />)
        }) }
        
        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
          <DropdownToggle className="btn-add-pixel-badge">
            <FA icon={faPlus} title="Select pixel set" />
          </DropdownToggle>
          <DropdownMenu>
            {showEmptyMsg && <div className="text-center items-empty">
              {size(this.state.options) <= 0  && 'You have no Pixels Lists to select.'}
              <span className="btn-add-pixel-badge close-btn float-right" title="Close" onClick={this.toggle}><FA icon={faTimes} /></span>
            </div>}
            {size(this.state.options) > 0 && <div className="pixel-sets-select-items">{map(this.state.options, (pixelSet, idx) => {
              const value = pixelSet.id
              const selected = indexOf(selectedIds, value) > -1
            
              return (<DropdownItem value={value} key={pixelSet.id} onClick={this.onAdd(value)} active={selected} className={classNames({active:selected})}>
                {pixelSet.name} <PixelsIcons pixels={pixelSet.pixels} />
              </DropdownItem>)
            })}</div>}
            
            
            <ModalLink key={'add-new-pixel'} params={{onSuccess: this.onCreateSuccess}} to="newPixelSet" className="dropdown-item dropdown-item-primary text-center">add new pixels list</ModalLink>
          </DropdownMenu>
        </Dropdown>
        
      </span>
    )
  }
};


export default connect(mapStateToProps, matchDispatchToProps)(PixelSetsSelect);


// WEBPACK FOOTER //
// ./src/components/PixelSets/PixelSetsSelect.js